import {ErrorHandler, Injectable} from '@angular/core';
import {AppInsightsLoggerService} from './app-insights-logger.service';
import {HttpErrorResponse} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
/**
 * This class is responsible to handling any errors
 * that was not previously handled by downstream components.
 */
export class GlobalErrorHandlerService implements ErrorHandler {

  constructor(private appInsightsLoggerService: AppInsightsLoggerService) { }

  /**
   * Handles the error that is not already handled by any other downstream components.
   * @param error Error that is not handled by downstream components.
   */
  handleError(error: any): void {
    /*
     * We could have different types of Error that might need to be processed by this method.
     * If the error type is HttpErrorResponse, we have certain key value pairs available.
     * Hence we are adding a conditional logic to parse those key/value pairs to display those information accordingly.
     */
    if (error instanceof HttpErrorResponse) {
      this.appInsightsLoggerService.log('Error', 'Error handled by Global Error Handler', `Failed to make a request to URL = ${error.url}. Error status code received = ${error.status}. Error status text received = ${error.statusText}`);
    } else {
      // TODO: We should iteratively improve the parsing of the following error object as needed in the future.
        if(this.appInsightsLoggerService){
          this.appInsightsLoggerService.log('Error', 'Error handled by Global Error Handler', error.toString());
        }



    }
  }
}
